<template>
  <section class="article-listing">
    <div class="article-listing__inner">
      <div class="article-listing__cards">
        <a
          v-for="(card, index) in cards"
          :key="index"
          :href="card.url"
          target="_blank"
          class="article-listing__card"
        >
          <div class="article-listing__card-image">
            <img v-if="isMobile"
              :src="card.image.mobile_src"
              :alt="card.image.mobile_alt"
            />
            <img v-else
              :src="card.image.src"
              :alt="card.image.alt"
            />
          </div>
          <span v-if="card.category" class="article-listing__tag">{{ card.category }}</span>
          <h3 v-if="card.title" class="article-listing__card-title">{{ card.title }}</h3>
          <p v-if="card.description" class="article-listing__description">{{ card.description }}</p>
          <div class="article-listing__card-meta">
            <svg
              class="article-listing__card-icon"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <g :clip-path="'url(#hairRoutineClip' + index + ')'">
                <path
                  d="M10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0Z"
                  fill="currentColor"
                />
                <path
                  d="M10 5V10"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-miterlimit="10"
                  stroke-linecap="square"
                />
                <path
                  d="M13 10H10"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-miterlimit="10"
                  stroke-linecap="square"
                />
              </g>
              <defs>
                <clipPath :id="'hairRoutineClip' + index">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span class="article-listing__card-read-time">{{ card.readTime }}</span>
          </div>
          <a
          :key="index"
          :href="card.url"
          target="_blank"
          class="article-listing__read"
        >{{ card.readMoreText }}</a>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'article-listing',

  props: {
    cards: {
      type: Array,
      default: () => [
      ],
    },
  },
  data() {
    return {
      isMobile: window.innerWidth < 768
    };
  },
};
</script>
